import { Injector } from '@angular/core';
import { registerIcons } from '@uifabric/styling';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import MeetNowButtonComponent from '../../shell-header-icon/meet-now-button.react-component';
import { OfficeRoute } from '../constants/office-route.enum';
import { InstrumentationService } from '../instrumentation/instrumentation.service';
import { ObservableScope } from '../models/observable-scope.enum';
import { AppEvent, EventService } from '../services/event.service';
import { OfficeRouteService } from '../services/office-route.service';
import { AngularEvents } from '../shared-context/angular-events';
import { ContextService } from '../shared-context/context.service';
import { LocService } from '../shared-context/loc.service';
import { ReactShellConfigService } from '../shared-context/react-shell-config.service';

export class MeetNowButton {
    private container: HTMLDivElement;
    private routeChangeEndSubscription: Subscription;
    private renderMeetNowSubscription: Subscription;

    constructor(
        private readonly contextService: ContextService,
        private readonly eventService: EventService,
        private readonly injector: Injector,
        private readonly officeRouteService: OfficeRouteService
    ) {
        registerIcons({
            icons: {
                'meetNowIcon': (
                    <svg width='24' height='24' viewBox='0 0 24 24' fill='none'>
                        <path d='M17.3995 19.5538C17.7841 19.4 18.2206 19.5871 18.3744 19.9717C18.5281 20.3563 18.341 20.7928 17.9564 20.9466C16.2532 21.6275 14.1784 22 12.0001 22C9.82685 22 7.75657 21.6292 6.05545 20.9512C5.67068 20.7978 5.48309 20.3615 5.63646 19.9768C5.78983 19.592 6.22608 19.4044 6.61086 19.5578C8.12904 20.1629 10.0112 20.5 12.0001 20.5C13.9936 20.5 15.8797 20.1614 17.3995 19.5538ZM12.7459 5.99594C14.4712 5.99594 15.8824 7.34018 15.9894 9.0384L18.9103 7.57652C19.4088 7.327 19.9956 7.6893 19.9959 8.24678L20.0002 15.7465C20.0005 16.3042 19.4136 16.6672 18.9147 16.4178L15.9894 14.9545C15.8818 16.6522 14.4708 17.9958 12.7459 17.9958H7.24609C5.45117 17.9958 3.99609 16.5407 3.99609 14.7458V9.24594C3.99609 7.45102 5.45117 5.99594 7.24609 5.99594H12.7459ZM12.7459 7.49594H7.24609C6.2796 7.49594 5.49609 8.27945 5.49609 9.24594V14.7458C5.49609 15.7123 6.2796 16.4958 7.24609 16.4958H12.7459C13.7124 16.4958 14.4959 15.7123 14.4959 14.7458V9.24594C14.4959 8.27945 13.7124 7.49594 12.7459 7.49594ZM18.4966 9.46093L15.9965 10.7122L15.9996 13.2831L18.4995 14.5331L18.4966 9.46093ZM12.0001 2C14.1737 2 16.2442 2.37086 17.9454 3.04907C18.3302 3.20247 18.5178 3.63873 18.3644 4.02349C18.211 4.40826 17.7747 4.59582 17.39 4.44243C15.8717 3.83715 13.9894 3.5 12.0001 3.5C10.0032 3.5 8.114 3.83981 6.59296 4.44937C6.20847 4.60346 5.77187 4.41668 5.61779 4.0322C5.4637 3.64771 5.65048 3.21111 6.03496 3.05702C7.73977 2.37381 9.81799 2 12.0001 2Z' fill='#252423'></path>
                    </svg>
                ),
                'meetNowIconWhite': (
                    <svg width='24' height='24' viewBox='0 0 24 24' fill='none'>
                        <path d='M17.3995 19.5538C17.7841 19.4 18.2206 19.5871 18.3744 19.9717C18.5281 20.3563 18.341 20.7928 17.9564 20.9466C16.2532 21.6275 14.1784 22 12.0001 22C9.82685 22 7.75657 21.6292 6.05545 20.9512C5.67068 20.7978 5.48309 20.3615 5.63646 19.9768C5.78983 19.592 6.22608 19.4044 6.61086 19.5578C8.12904 20.1629 10.0112 20.5 12.0001 20.5C13.9936 20.5 15.8797 20.1614 17.3995 19.5538ZM12.7459 5.99594C14.4712 5.99594 15.8824 7.34018 15.9894 9.0384L18.9103 7.57652C19.4088 7.327 19.9956 7.6893 19.9959 8.24678L20.0002 15.7465C20.0005 16.3042 19.4136 16.6672 18.9147 16.4178L15.9894 14.9545C15.8818 16.6522 14.4708 17.9958 12.7459 17.9958H7.24609C5.45117 17.9958 3.99609 16.5407 3.99609 14.7458V9.24594C3.99609 7.45102 5.45117 5.99594 7.24609 5.99594H12.7459ZM12.7459 7.49594H7.24609C6.2796 7.49594 5.49609 8.27945 5.49609 9.24594V14.7458C5.49609 15.7123 6.2796 16.4958 7.24609 16.4958H12.7459C13.7124 16.4958 14.4959 15.7123 14.4959 14.7458V9.24594C14.4959 8.27945 13.7124 7.49594 12.7459 7.49594ZM18.4966 9.46093L15.9965 10.7122L15.9996 13.2831L18.4995 14.5331L18.4966 9.46093ZM12.0001 2C14.1737 2 16.2442 2.37086 17.9454 3.04907C18.3302 3.20247 18.5178 3.63873 18.3644 4.02349C18.211 4.40826 17.7747 4.59582 17.39 4.44243C15.8717 3.83715 13.9894 3.5 12.0001 3.5C10.0032 3.5 8.114 3.83981 6.59296 4.44937C6.20847 4.60346 5.77187 4.41668 5.61779 4.0322C5.4637 3.64771 5.65048 3.21111 6.03496 3.05702C7.73977 2.37381 9.81799 2 12.0001 2Z' fill='#FFFFFF'></path>
                    </svg>
                )
            }
        });

        this.subscribe();
    }

    public unsubscribe() {
        if (this.routeChangeEndSubscription) {
            this.routeChangeEndSubscription.unsubscribe();
        }

        if (this.renderMeetNowSubscription) {
            this.renderMeetNowSubscription.unsubscribe();
        }
    }

    private subscribe(): void {
        this.renderMeetNowSubscription = this.eventService.events.withScope(ObservableScope.PastAndFuture)
            .pipe(filter(event => event.name === AngularEvents.renderMeetNowButton))
            .subscribe((event: AppEvent) => {
                if (event.args.length) {
                    this.container = event.args[0];

                    this.routeChangeEndSubscription = this.officeRouteService.subscribeToRouteChangeEnd(routes => {
                        if (!React) {
                            return;
                        }

                        // On route change, use corresponding icon svg
                        // TODO: find a way to read the color value of o365sx-button and render icon with corresponding 'fill' value.
                        const currentRoute: OfficeRoute = routes.currentRoute.route;

                        ReactDOM.render(
                            <MeetNowButtonComponent
                                route={currentRoute}
                                locService={this.injector.get(LocService)}
                                instrumentationService={this.injector.get(InstrumentationService)}
                                reactShellConfigService={this.injector.get(ReactShellConfigService)}
                                linkTarget={this.contextService.sharedContext.defaultLinkTarget}/>,
                            this.container
                        );
                    });
                }
            });
    }
}
